import Vue from 'vue'
import numeral from 'numeral'
import { DateTime } from "luxon"
import {
    STATUS_APPROVED,
    STATUS_DECLINED,
    STATUS_IN_REVIEW,
} from '../store/models/applications/model'
import { get } from 'lodash'

Vue.filter('date', date => {
    if (!date) return ''
    let _date = DateTime.fromISO(date, {zone: 'UTC'}).toLocal()
    return _date.toFormat('yyyy-MM-dd')
})

Vue.filter('datetime', date => {
    if (!date) return ''
    let _date = DateTime.fromISO(date, {zone: 'UTC'}).toLocal()
    return _date.toFormat('yyyy-MM-dd HH:mm')
})

Vue.filter('formatMSS', number => {
    number = parseInt(number)
    return numeral(Math.ceil(number) || 0).format('00:00:00').replace(/^0:0|0:/, '')
})

Vue.filter('seconds2duration', number => {
    let seconds = number

    const hours = Math.floor(seconds / 3600)
    seconds = seconds % 3600
    const minutes = Math.floor(seconds / 60)
    seconds = seconds % 60

    let string = ''

    if (hours > 0) {
        string += `${hours}ч `
    }
    if (minutes > 0) {
        string += `${minutes}мин `
    }
    if (seconds > 0) {
        string += `${seconds}сек`
    }
    if (!hours && !seconds && !minutes) {
        return '0'
    }

    return string.trim()
})

Vue.filter('cutText', (value, length=10) => {
    if(!value){ return null }

    if(value.length <= length) {
        return value;
    }

    return value.substring(0, length) + '...';
})

Vue.filter('num', (number, format='00') => {
    return numeral(number).format(format)
})


Vue.filter('appStatusToText', (status) => {
    switch (status) {
        case STATUS_APPROVED:
            return 'Подтвержденный'
        case STATUS_DECLINED:
            return 'Отклоненный'
        case STATUS_IN_REVIEW:
            return 'Ожидает проверки'
    }
})

Vue.filter('objectPath', (obj, key = 'name', split = ' -> ') => {
    let names = []
    const f = (obj) => {
        let name = get(obj, key)
        if (name) names.push(name)
        if (obj && obj.parent) {
            f(obj.parent)
        }
    }
    f(obj)

    return names.reverse().join(split)
})
